import type { DataTableColumn } from '@/components/custom/erp';
import type { QuanHuyen, TinhThanh } from '@/types/schemas';

export const provinceColumns: DataTableColumn<TinhThanh>[] = [
  {
    field: 'ma_tinh',
    headerName: 'Mã tỉnh/thành',
    width: 150
  },
  {
    field: 'ten_tinh',
    headerName: 'Tên tỉnh/thành',
    width: 200
  }
];

export const getDataTableColumns = (): DataTableColumn<QuanHuyen & { ten_tinh?: string }>[] => {
  return [
    {
      field: 'ma_quan',
      headerName: 'Mã quận/huyện',
      width: 150
    },
    {
      field: 'ten_quan',
      headerName: 'Tên quận/huyện',
      width: 200
    },
    {
      field: 'ma_tinh',
      headerName: 'Mã tỉnh/thành',
      width: 150
    },
    {
      field: 'ten_tinh',
      headerName: 'Tên tỉnh/thành',
      width: 200
    }
  ];
};
